import React, { Suspense, lazy } from "react";
import { Navigate } from "react-router-dom";
import { type RouteObject } from "react-router";
import SidebarLayout from "./layouts/SidebarLayout";
import SuspenseLoader from "./components/SuspenseLoader";
import BaseLayout from "./layouts/BaseLayout";

const Loader = (Component: React.ComponentType): React.ComponentType => {
  const WrappedComponent: React.FC = (props: any) => (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

  WrappedComponent.displayName = `Loader(${Component.displayName ?? Component.name ?? "Component"})`;

  return WrappedComponent;
};

const NavigationHistoryDetail = Loader(
  lazy(
    async () =>
      await import(
        "src/content/pages/NavigationHistory/components/NavigationHistoryDetail"
      ),
  ),
);
const Status404 = Loader(
  lazy(async () => await import("src/content/pages/Status404")),
);
const Friend = Loader(
  lazy(async () => await import("src/content/pages/Friend")),
);
const FriendDetail = Loader(
  lazy(
    async () =>
      await import("src/content/pages/Friend/components/FriendDetail"),
  ),
);
const FriendNavigationDetail = Loader(
  lazy(
    async () =>
      await import(
        "src/content/pages/Friend/components/FriendNavigationDetail"
      ),
  ),
);

const routes: RouteObject[] = [
  {
    path: "",
    element: <SidebarLayout />,
    children: [
      {
        path: "",
        element: <Navigate to="friend" replace />,
      },
      {
        path: "friend",
        element: <Friend />,
      },
    ],
  },
  {
    path: "",
    element: <SidebarLayout />,
    children: [
      {
        path: "",
        element: <Navigate to="user" replace />,
      },
      {
        path: "navigation_history/:navigationId",
        element: <NavigationHistoryDetail />,
      },
    ],
  },
  {
    path: "",
    element: <SidebarLayout />,
    children: [
      {
        path: "",
        element: <Navigate to="friend" replace />,
      },
      {
        path: "friend",
        element: <Friend />,
      },
      {
        path: "friend/:userId",
        element: <FriendDetail />,
      },
      {
        path: "friend/navigation/:navigationId",
        element: <FriendNavigationDetail />,
      },
    ],
  },
  {
    path: "",
    element: <BaseLayout />,
    children: [
      {
        path: "*",
        element: <Status404 />,
      },
    ],
  },
];

export default routes;
